import $ from 'jquery';

function Stats(element) {
  this.$element = $(element);
  this.init();
  this.ready();
}

Stats.prototype = {
  init() {
    this.$element.find('.subtitle').wrap('<span class="subtitle-wrapper"></span>');
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default Stats;
